import React from 'react'
import { Helmet } from 'react-helmet-async'

const StructuredData = () => {
  const baseUrl = typeof window !== 'undefined' ? window.location.origin : 'https://vdpms.in'
  
  const schoolData = {
    "@context": "https://schema.org",
    "@type": "EducationalOrganization",
    "name": "Shri V.D. Patel Madhyamik School",
    "alternateName": ["V.D. Patel School", "SPET Mandavad", "Sardar Patel Educational Trust School"],
    "url": baseUrl,
    "logo": `${baseUrl}/logo.jpeg`,
    "image": [`${baseUrl}/logo.jpeg`, `${baseUrl}/public/about/sardar-patel.jpg`],
    "description": "Shri V.D. Patel Madhyamik School, operated by Sardar Patel Educational Trust, is a premier educational institution providing quality education from primary to secondary levels with a focus on character building, academic excellence, and holistic development since 1996.",
    "foundingDate": "1996",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "V.D. Patel Educational Complex, Post Box No 15, Visavadar-Junagadh Highway, Mandavad, Ta. Visavadar",
      "addressLocality": "Mandavad",
      "addressRegion": "Gujarat",
      "postalCode": "362130",
      "addressCountry": "IN"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "21.3493",
      "longitude": "70.7512"
    },
    "contactPoint": [
      {
        "@type": "ContactPoint",
        "telephone": "+91-9687685102",
        "contactType": "Admissions",
        "areaServed": "IN-GJ",
        "availableLanguage": ["English", "Gujarati", "Hindi"],
        "email": "mandavadsankul1996@gmail.com"
      },
      {
        "@type": "ContactPoint",
        "telephone": "+91-9687685102",
        "contactType": "Customer Service",
        "areaServed": "IN-GJ",
        "availableLanguage": ["English", "Gujarati", "Hindi"]
      }
    ],
    "sameAs": [
      baseUrl,
      "https://x.com/mandavadsankul",
      "https://twitter.com/mandavadsankul"
    ],
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Academic Programs",
      "board": "Gujarati Secondary Education Board",
      "itemListElement": [
        {
          "@type": "Course",
          "name": "Primary Education (Grades 1-5)",
          "description": "Comprehensive primary education focusing on foundational skills in languages, mathematics, science, and social studies with emphasis on character development",
          "provider": {
            "@type": "EducationalOrganization",
            "name": "Shri V.D. Patel Madhyamik School"
          },
          "educationalLevel": "Primary Education",
          "inLanguage": ["en", "gu", "hi"]
        },
        {
          "@type": "Course", 
          "name": "Secondary Education (Grades 6-10)",
          "description": "Quality secondary education preparing students for board examinations with comprehensive curriculum in sciences, mathematics, languages, and social sciences",
          "provider": {
            "@type": "EducationalOrganization",
            "name": "Shri V.D. Patel Madhyamik School"
          },
          "educationalLevel": "Secondary Education",
          "inLanguage": ["en", "gu", "hi"]
        }
      ]
    },
    "alumni": {
      "@type": "AlumniAssociation",
      "name": "Shri V.D. Patel Madhyamik School Alumni Network",
      "description": "Active alumni network with successful professionals across various fields worldwide"
    },
    "areaServed": {
      "@type": "GeoCircle",
      "geoMidpoint": {
        "@type": "GeoCoordinates",
        "latitude": "21.3493",
        "longitude": "70.7512"
      },
      "geoRadius": "50000"
    }
  }

  const breadcrumbData = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": baseUrl
      }
    ]
  }

  // FAQ Schema for common questions
  const faqData = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "Where is Shri V.D. Patel Madhyamik School located?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Shri V.D. Patel Madhyamik School is located at V.D. Patel Educational Complex, Visavadar-Junagadh Highway, Mandavad, Ta. Visavadar, Dist. Junagadh - 362130, Gujarat, India."
        }
      },
      {
        "@type": "Question",
        "name": "What grades does the school offer?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "The school offers education from Primary (Grades 1-5) to Secondary (Grades 6-10) levels with comprehensive curriculum in both English and Gujarati mediums."
        }
      },
      {
        "@type": "Question",
        "name": "How can I contact the school for admissions?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "You can contact us at +91-9687685102 or email us at mandavadsankul1996@gmail.com for admission inquiries. Our office is open Monday to Saturday from 8:00 AM to 4:00 PM."
        }
      },
      {
        "@type": "Question",
        "name": "What is the school operated by?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "The school is operated by Sardar Patel Educational Trust (SPET), a non-profit organization dedicated to providing quality education since 1996."
        }
      }
    ]
  }

  // WebSite Schema for search box
  const websiteData = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Shri V.D. Patel Madhyamik School",
    "alternateName": "V.D. Patel School",
    "url": baseUrl,
    "potentialAction": {
      "@type": "SearchAction",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": `${baseUrl}/?s={search_term_string}`
      },
      "query-input": "required name=search_term_string"
    }
  }

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schoolData)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(breadcrumbData)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(faqData)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(websiteData)}
      </script>
    </Helmet>
  )
}

export default StructuredData